export default __webpack_public_path__ + "static/media/Refined Philtre of Wisdom.cc73f375.jpg";